// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Add other environment-specific variables here
  debugMode: true,
  // AWS API Gateway base URL for development
  baseApiUrl: 'https://oxdxaikiik.execute-api.ap-southeast-1.amazonaws.com',
  // Testing flag for API calls
  forTesting: true,
  // Auth configuration for development/testing
  auth: {
    authority: 'https://cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_7QQHKkTeK',
    redirectUrl: 'https://hkdef-test.infinite6.net/callback',
    clientId: '2ebsffne83in28o0pv9mkdk86l',
  },
}; 